import { render, staticRenderFns } from "./SummaryValue.vue?vue&type=template&id=408a5faa&"
import script from "./SummaryValue.vue?vue&type=script&lang=js&"
export * from "./SummaryValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('408a5faa')) {
      api.createRecord('408a5faa', component.options)
    } else {
      api.reload('408a5faa', component.options)
    }
    module.hot.accept("./SummaryValue.vue?vue&type=template&id=408a5faa&", function () {
      api.rerender('408a5faa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Calculators/Global/SummaryValue.vue"
export default component.exports